import { createSelector } from '@reduxjs/toolkit';

import { User } from '@paragon/contract-library';
import { naturalSortByProperty } from '@paragon/utilities';

import { OrganizationMembersSliceState } from '../store/organizationMembersSlice';
import { getUserDisplayName } from '../userNames';

export const getOrganizationMembersStatus = (state: OrganizationMembersSliceState) => state.organizationMembers.status;

export const getOrganizationMembers = createSelector(
  (state: OrganizationMembersSliceState) => state.organizationMembers.members,
  (members) => naturalSortByProperty(members, getUserDisplayName),
);

export const getOrganizationMembersByEmail = createSelector(getOrganizationMembers, (members) =>
  Object.fromEntries(members.map((member) => [member.email, member])),
);

export function getOrganizationMemberIfLoaded(state: OrganizationMembersSliceState, email: string): User | undefined {
  return getOrganizationMembersByEmail(state)[email];
}
